export default __webpack_public_path__ + "static/media/Team2.aaf3b5e6.jpg";